import {
  Component,
  OnInit,
  Input,
  HostListener,
  ElementRef,
  Renderer2,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Option, TableHandler, Cell } from '../../../../../../classes';
import {
  AuthService,
  ReplyService,
  TransactionService
} from '../../../../../../services';
import { AngularFireDatabase } from '@angular/fire/database';
import { OptionComponent } from '../../../options/abstract/option.component';

@Component({
  selector: '[regular-cell]',
  templateUrl: './regular-cell.component.html',
  styleUrls: ['./regular-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegularCellComponent extends OptionComponent implements OnInit {
  @Input() table: TableHandler;
  @Input() cell: Cell;
  get option(): Option {
    return this.cell.option;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    reply: ReplyService,
    auth: AuthService,
    transaction: TransactionService,
    db: AngularFireDatabase,
    cdRef: ChangeDetectorRef
  ) {
    super(reply, auth, transaction, db, cdRef);
  }

  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    this.renderer.addClass(this.elementRef.nativeElement, 'ellipsis');
    super.ngOnInit();
  }
  refreshFilled(quota: number, filled_up_to: number) {
    super.refreshFilled(quota, filled_up_to);

    if (this.filled)
      this.renderer.addClass(this.elementRef.nativeElement, 'filled');
    else this.renderer.removeClass(this.elementRef.nativeElement, 'filled');
    if (this.disabled)
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
    else this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');
  }

  refreshCheckStatus() {
    if (this.checkStatus)
      this.renderer.removeClass(
        this.elementRef.nativeElement,
        this.checkStatus
      );
    super.refreshCheckStatus();
    if (this.checkStatus)
      this.renderer.addClass(this.elementRef.nativeElement, this.checkStatus);
  }
  @HostListener('click', [])
  toggleCheck() {
    super.toggleCheck();
    // if (this.disabled) return false;
    // if (this.checkStatus && this.checkStatus.match('ing')) return false;
    // const checking = !this.reply.isChecked(this.option, undefined, this.as);
    // this.reply.toggle(this.option, checking ? 0 : null);
  }
}
